<div class="login-overlay" role="dialog" aria-modal="true" [attr.aria-label]="isRegisterMode ? 'Create account' : 'Sign in'">
  <div class="login-overlay__backdrop" aria-hidden="true"></div>

  <div class="login-overlay__sheet">
    <header class="login-overlay__header">
      <button type="button" class="login-overlay__icon-btn" (click)="onBack()" aria-label="Go back">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="m14 18-6-6 6-6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      <div class="login-overlay__header-main">
        <p class="login-overlay__brand">TekMegha</p>
        <span class="login-overlay__header-sep" aria-hidden="true">·</span>
        <h1 class="login-overlay__title">
          @if (step === 'identifier') {
            {{ isRegisterMode ? 'Create your account' : 'Sign in' }}
          } @else {
            {{ isRegisterMode ? 'Set your password' : 'Enter your password' }}
          }
        </h1>
      </div>
    </header>

    @if (step !== 'identifier') {
      <p class="login-overlay__subtitle">
        @if (isRegisterMode) {
          Choose a secure password for your account
        } @else {
          Enter the password for your account
        }
      </p>
    }

    <form class="login-overlay__form" (ngSubmit)="onFormSubmit()">
      @if (step === 'identifier') {
        <msde-floating-input
          label="Email or mobile"
          type="text"
          name="identifier"
          [(ngModel)]="email"
          autocomplete="username"
          inputmode="email"
          required
        />

        @if (errorMessage) {
          <p class="login-alert login-alert--error" role="alert">{{ errorMessage }}</p>
        }

        @if (successMessage) {
          <p class="login-alert login-alert--success" role="status">{{ successMessage }}</p>
        }

        <button
          type="submit"
          class="login-primary-btn login-primary-btn--follow"
          [disabled]="isLoading || !canContinueIdentifier"
        >
          Next
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">
            <path d="M5 12h14M13 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      } @else {
        <div class="login-identifier-chip">
          <span class="login-identifier-chip__label">Signing in as</span>
          <span class="login-identifier-chip__value">{{ email.trim() }}</span>
          <button type="button" class="login-identifier-chip__change" (click)="changeIdentifier()">Change</button>
        </div>

        <msde-floating-input
          #secretInput
          label="Password"
          [type]="showPassword ? 'text' : 'password'"
          name="password"
          [(ngModel)]="password"
          [autocomplete]="isRegisterMode ? 'new-password' : 'current-password'"
          required
        >
          <button
            msdeSuffix
            type="button"
            class="login-password-toggle"
            (click)="toggleShowPassword()"
            [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
            [attr.aria-pressed]="showPassword"
          >
            <span class="material-icons" aria-hidden="true">{{ showPassword ? 'visibility_off' : 'visibility' }}</span>
          </button>
        </msde-floating-input>

        @if (isRegisterMode) {
          <msde-floating-input
            label="Confirm password"
            [type]="showPassword ? 'text' : 'password'"
            name="confirmPassword"
            [(ngModel)]="confirmPassword"
            autocomplete="new-password"
            required
          >
            <button
              msdeSuffix
              type="button"
              class="login-password-toggle"
              (click)="toggleShowPassword()"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
              [attr.aria-pressed]="showPassword"
            >
              <span class="material-icons" aria-hidden="true">{{ showPassword ? 'visibility_off' : 'visibility' }}</span>
            </button>
          </msde-floating-input>
        }
      }

      @if (step === 'secret') {
        @if (errorMessage) {
          <p class="login-alert login-alert--error" role="alert">{{ errorMessage }}</p>
        }

        @if (successMessage) {
          <p class="login-alert login-alert--success" role="status">{{ successMessage }}</p>
        }

        <button
          type="submit"
          class="login-primary-btn login-primary-btn--bottom"
          [disabled]="isLoading || !canSubmit"
          [class.login-primary-btn--loading]="isLoading"
        >
          @if (isLoading) {
            <span class="login-spinner" aria-hidden="true"></span>
            {{ isRegisterMode ? 'Creating account…' : 'Signing in…' }}
          } @else {
            {{ isRegisterMode ? 'Create account' : 'Sign in' }}
          }
        </button>

        @if (!isRegisterMode) {
          <p class="login-links">
            <button type="button" class="login-link" (click)="onForgotPassword()">Forgot password?</button>
          </p>
        }
      }
    </form>

    <footer class="login-overlay__footer">
      <p class="login-footer-text">
        @if (isRegisterMode) {
          Already have an account?
          <button type="button" class="login-link login-link--strong" (click)="setSignInMode()">Sign in</button>
        } @else {
          New here?
          <button type="button" class="login-link login-link--strong" (click)="setRegisterMode()">Create account</button>
        }
      </p>
      <p class="login-terms">
        @if (isRegisterMode) {
          By creating an account you agree to our
          <a href="/tnc.html" target="_blank" rel="noopener noreferrer" class="login-terms-link">Terms &amp; Conditions</a>
          and
          <a href="/privacy-policy.html" target="_blank" rel="noopener noreferrer" class="login-terms-link">Privacy Policy</a>.
        } @else {
          By signing in you agree to our
          <a href="/tnc.html" target="_blank" rel="noopener noreferrer" class="login-terms-link">Terms &amp; Conditions</a>
          and
          <a href="/privacy-policy.html" target="_blank" rel="noopener noreferrer" class="login-terms-link">Privacy Policy</a>.
        }
      </p>
    </footer>
  </div>
</div>
